export default __webpack_public_path__ + "static/dave-wescott-transblue-b88ef8c4afe00bb638629f7b536a5760.png";